import { useGetOnboardingStatusQuery } from 'store/api/customer.apislice';
import { useGetCurrentSubscriptionQuery } from 'store/api/subscription.apislice';
import { useNavigate } from 'react-router-dom';
import ROUTES from 'router/routes.constants';
import toast from 'react-hot-toast';
import {
  getInvestmentEligibility,
  isOnboardingComplete,
} from 'utils/investmentEligibility.utils';

export const usePlanGate = () => {
  const navigate = useNavigate();
  const { data: onboardingData } = useGetOnboardingStatusQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const { data: currentSubscription } = useGetCurrentSubscriptionQuery();

  const isPaidSubscription =
    currentSubscription?.result?.status === 'ACTIVE' ||
    currentSubscription?.result?.current?.status === 'ACTIVE';

  const eligibility = getInvestmentEligibility(onboardingData, {
    isSubscriptionActive: isPaidSubscription,
  });

  const {
    customerType,
    isFreeCustomer,
    isDirect,
    shouldSkipPlanSelection,
  } = eligibility;

  const isSubscriptionActive = isPaidSubscription || isFreeCustomer || customerType === 'REGULAR';

  const isPlanDisabled =
    !isFreeCustomer &&
    (!customerType || (isDirect && !isSubscriptionActive));

  const requirePlanSelection = (skipKyc = false) => {
    if (shouldSkipPlanSelection) {
      if (!skipKyc && !isOnboardingComplete(onboardingData)) {
        navigate(ROUTES.ONBOARDING_STATUS);
        toast.error("Please complete your onboarding details first.");
        return true;
      }
      return false;
    }

    if (!customerType) {
      window.dispatchEvent(new Event('open-plan-selection-modal'));
      return true;
    }

    if (!skipKyc && !isOnboardingComplete(onboardingData)) {
      navigate(ROUTES.ONBOARDING_STATUS);
      toast.error("Please complete your onboarding details first.");
      return true;
    }

    if (isDirect && !isFreeCustomer) {
      const { nextAction } = getInvestmentEligibility(onboardingData, {
        isSubscriptionActive: isPaidSubscription,
      });

      if (nextAction === 'risk') {
        window.dispatchEvent(new Event('open-risk-assessment-modal'));
        return true;
      }

      if (nextAction === 'payment') {
        window.dispatchEvent(new Event('open-plan-selection-modal'));
        return true;
      }

      if (nextAction === 'agreement') {
        window.dispatchEvent(new Event('open-agreement-modal'));
        return true;
      }
    }

    return false;
  };

  return { isPlanDisabled, requirePlanSelection };
};
